"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useColumns = void 0;
const react_intl_1 = require("react-intl");
const table_cells_1 = require("../../../composite/table/table-cells");
/**
 * fixme: add iniciacni dokument
 */
function useColumns() {
    const intl = react_intl_1.useIntl();
    return [
        {
            datakey: 'recordSymbol',
            name: intl.formatMessage({
                id: 'ESS_RECORDS_COLUMN_RECORD_SYMBOL',
                defaultMessage: 'Spisová značka',
            }),
            width: 150,
            CellComponent: table_cells_1.TableCells.TextCell,
            sortable: true,
            filterable: true,
        },
        {
            datakey: 'name',
            name: intl.formatMessage({
                id: 'ESS_RECORDS_COLUMN_NAME',
                defaultMessage: 'Název',
            }),
            width: 200,
            CellComponent: table_cells_1.TableCells.TextCell,
            sortable: true,
            filterable: true,
        },
        {
            datakey: 'description',
            name: intl.formatMessage({
                id: 'ESS_RECORDS_COLUMN_DESCRIPTION',
                defaultMessage: 'Popis',
            }),
            width: 200,
            CellComponent: table_cells_1.TableCells.TextCell,
            sortable: true,
            filterable: true,
        },
        {
            datakey: 'classificationCode',
            name: intl.formatMessage({
                id: 'ESS_RECORDS_COLUMN_CLASSIFICATION_CODE',
                defaultMessage: 'Spisový znak',
            }),
            width: 120,
            CellComponent: table_cells_1.TableCells.TextCell,
            sortable: true,
            filterable: true,
        },
        {
            datakey: 'barCode',
            name: intl.formatMessage({
                id: 'ESS_RECORDS_COLUMN_BARCODE',
                defaultMessage: 'Čárový kód',
            }),
            width: 120,
            CellComponent: table_cells_1.TableCells.TextCell,
            sortable: true,
            filterable: true,
        },
    ];
}
exports.useColumns = useColumns;
//# sourceMappingURL=records-columns.js.map